module.exports = __webpack_public_path__ + "img/Middle-Vertical-Rectangular-Attachment-33.b5f13f76.png";